import { useState } from 'react';
import { useIntervalWhen } from 'rooks';

const useCheckChatInitialized = ({ defer }: { defer: () => boolean }) => {
  const [ready, setReady] = useState(defer?.());
  useIntervalWhen(() => defer?.() && setReady(true), 1000, !ready);

  return { isChatSupportReady: ready };
};

export default useCheckChatInitialized;
